<div class="modal-body text-center" role="dialog" aria-labelledby="update-doc-title" aria-modal="true">
  <div class="modal-header d-flex justify-content-between align-items-center mb-4">
    <h4 id="update-doc-title" class="fw-bold fs-20 w-100 text-center mb-0">{{ title }}</h4>
    <button class="btn-close position-absolute end-0 top-0 m-2" aria-label="Close" (click)="bsModalRef.hide()">
      <img src="/assets/images/Cross1.png" alt="Close" class="img-fluid close-icon" />
    </button>
  </div>

  <div class="action--form">
    <div class="form-details {{ customClass }}">
      <img *ngIf="showImage" [src]="image" class="img-fluid confirm-image mb-3" alt="Confirmation Image" />

      <h2 class="header-title fw-bold">{{ headerTitle }}</h2>
      <h6 class="fw-medium subtitle mb-4">{{ headerSubTitle }}</h6>

      <div class="d-flex justify-content-center gap-3 flex-wrap">
        <button *ngIf="showConfirmButton" class="btn btn-primary btn-lg px-4" (click)="submitForm()">
          {{ confirmText }}
        </button>
        <button class="btn btn-outline-secondary btn-lg px-4" (click)="!emitOnClose ? bsModalRef.hide() : submitForm(false)">
          {{ closeText }}
        </button>
      </div>
    </div>
  </div>
</div>
